module.exports = __webpack_public_path__ + "static/media/Active_Graph_Icon.826cf109.svg";